module.exports = __webpack_public_path__ + "static/Neue-Haas-Grotesk-Text-75-42a962c2dd8fbe41c27eb54f05754d42.woff2";